import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import "./NonRecipientsMourners.scss";
import { ReactComponent as PrintIcon } from "assets/icons/print_yah.svg";
import MournerItem from "../RecipientsMourners/MournerItem";
import jsPDF from "jspdf";
import moment from "moment";
import { DateFormetContext } from "../../../../../app/App.js";
import FinancialSetting from "Lib/API/FinanceSetting/FinanceSetting";
import { useAuth0 } from "@auth0/auth0-react";
import { toastr } from "react-redux-toastr";
import {
  Page,
  Document,
  StyleSheet,
  View,
  Font,
  Image,
  Text,
} from "@react-pdf/renderer";
import Html from "react-pdf-html";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";

const NonRecipientsMourners = ({ values, setFieldValue }) => {
  const dateFormet = React.useContext(DateFormetContext);
  const { selectedDeceased } = useSelector((state) => state.CommonStates);
  const [templateContent, setTemplateContent] = useState("");
  const [loading, setLoading] = useState(false);
  const { getAccessTokenSilently } = useAuth0();

  const addLogo = useSelector((state) => state.CommonStates.addLogo);

  const orgData = JSON.parse(
    localStorage.getItem("organization") !== "undefined"
      ? localStorage.getItem("organization")
      : "{}"
  );
  const logoImg = orgData?.logoImg;
  const orgName = orgData?.orgName;
  const address = orgData?.contactInfo?.address;
  const phone = orgData?.contactInfo?.phone;

  let selectedMourners = [];
  const mourners = selectedDeceased?.map((dec) => {
    return dec?.mourners_list?.forEach((item) => {
      selectedMourners.push({
        ...item,
        "Deceased name": dec?.name,
        "hebrew name of Death": dec?.hebrew_name_of_Death,
        "hebrew date of death": dec?.hebrew_date_of_death,
        "mother name": dec?.mother_name,
        "date of death":
          dec?.date_of_death &&
          moment(dec?.date_of_death).utcOffset("+0100").format(dateFormet),
        "mourners relation": item?.relation,
        gender: dec?.gender,
        "about the deceased": dec?.about_the_deceased,
        cemetery: dec?.cemetery,
        "plaque number": dec?.plaque_number,
        "First Name": item?.member_id?.first_name,
        "Middle Name": item?.member_id?.middle_name,
        "Last Name": item?.member_id?.last_name,
        "Hebrew Name": item?.member_id?.hebrew_name,
        Title: item?.member_id?.title,
        "Contact Gender": item?.member_id?.gender,
        Pronoun: item?.member_id?.pronounce,
        Status: item?.member_id?.social_status,
        "Date of Birth":
          item?.member_id?.date_of_birth &&
          moment(item?.member_id?.date_of_birth)
            .utcOffset("+0100")
            .format(dateFormet),
        "Mobile Number": item?.member_id?.mobile_number,
        "Home Number": item?.member_id?.home_phone,
        Email: item?.member_id?.email_address,
        "Emergency Contact Number": item?.member_id?.emergency_contact_number,
        Address: item?.member_id?.location?.formattedAddress,
        City: item?.member_id?.city,
        State: item?.member_id?.state,
        "Zip Code": item?.member_id?.zip_code,
        Occupation: item?.member_id?.occupation,
        Religion: item?.member_id?.religion,
        Relationship: item?.member_id?.relationship?.[0],
        Anniversary:
          item?.member_id?.anniversary_date &&
          moment(item?.member_id?.anniversary_date)
            .utcOffset("+0100")
            .format(dateFormet),
        "Bar-Bat Mitzvah":
          item?.member_id?.metva_date &&
          moment(item?.member_id?.metva_date)
            .utcOffset("+0100")
            .format(dateFormet),
        "Contact Tags": item?.member_id?.tags?.join(", "),
        "Account type": item?.member_id?.account?.payment?.account_type,
        Category: item?.member_id?.account?.payment?.account_sub_type?.title,
        "Billing type": item?.member_id?.account?.payment?.billing_type?.title,
        "Account name": item?.member_id?.account?.family_name,
        "Account ID": item?.member_id?.account?.account_id,
        "Family admin name": item?.member_id?.account?.admin_name,
        "Family admin contact": item?.member_id?.account?.admin_contact,
        "Old account ID": item?.member_id?.account?.old_account_id,
        "Active Address": item?.member_id?.account?.addresses?.find(
          (item) => item?.active === true
        )
          ? item?.member_id?.account?.addresses?.find(
              (item) => item?.active === true
            )?.location?.formattedAddress
          : "",
        "Active City": item?.member_id?.account?.addresses?.find(
          (item) => item?.active === true
        )
          ? item?.member_id?.account?.addresses?.find(
              (item) => item?.active === true
            )?.city
          : "",
        "Active State": item?.member_id?.account?.addresses?.find(
          (item) => item?.active === true
        )
          ? item?.member_id?.account?.addresses?.find(
              (item) => item?.active === true
            )?.state
          : "",
        "Active Zip code": item?.member_id?.account?.addresses?.find(
          (item) => item?.active === true
        )
          ? item?.member_id?.account?.addresses?.find(
              (item) => item?.active === true
            )?.zip_code
          : "",
        "Active Neighborhood": item?.member_id?.account?.addresses?.find(
          (item) => item?.active === true
        )
          ? item?.member_id?.account?.addresses?.find(
              (item) => item?.active === true
            )?.neighborhood
          : "",
        "Active Country": item?.member_id?.account?.addresses?.find(
          (item) => item?.active === true
        )
          ? item?.member_id?.account?.addresses?.find(
              (item) => item?.active === true
            )?.country
          : "",
        "Active Address Line2": item?.member_id?.account?.addresses?.find(
          (item) => item?.active === true
        )
          ? item?.member_id?.account?.addresses?.find(
              (item) => item?.active === true
            )?.addressLine2
          : "",
        "Billing Address": item?.member_id?.account?.addresses?.find(
          (item) => item?.billing === true
        )
          ? item?.member_id?.account?.addresses?.find(
              (item) => item?.billing === true
            )?.location?.formattedAddress
          : "",
        "Billing City": item?.member_id?.account?.addresses?.find(
          (item) => item?.billing === true
        )
          ? item?.member_id?.account?.addresses?.find(
              (item) => item?.billing === true
            )?.city
          : "",
        "Billing State": item?.member_id?.account?.addresses?.find(
          (item) => item?.billing === true
        )
          ? item?.member_id?.account?.addresses?.find(
              (item) => item?.billing === true
            )?.state
          : "",
        "Billing Zip code": item?.member_id?.account?.addresses?.find(
          (item) => item?.billing === true
        )
          ? item?.member_id?.account?.addresses?.find(
              (item) => item?.billing === true
            )?.zip_code
          : "",
        "Billing Neighborhood": item?.member_id?.account?.addresses?.find(
          (item) => item?.billing === true
        )
          ? item?.member_id?.account?.addresses?.find(
              (item) => item?.billing === true
            )?.neighborhood
          : "",
        "Billing Country": item?.member_id?.account?.addresses?.find(
          (item) => item?.billing === true
        )
          ? item?.member_id?.account?.addresses?.find(
              (item) => item?.billing === true
            )?.country
          : "",
        "Billing Address Line2": item?.member_id?.account?.addresses?.find(
          (item) => item?.billing === true
        )
          ? item?.member_id?.account?.addresses?.find(
              (item) => item?.billing === true
            )?.addressLine2
          : "",
        "Account Tags": item?.member_id?.account?.tags?.join(", "),
        "Join Date":
          item?.member_id?.account?.join_date &&
          moment(item?.member_id?.account?.join_date)
            .utcOffset("+0100")
            .format(dateFormet),
        "Resign Date":
          item?.member_id?.account?.resign_date &&
          moment(item?.member_id?.account?.resign_date)
            .utcOffset("+0100")
            .format(dateFormet),
        "next english yahrzeit":
          dec?.next_english_yhartzeit &&
          moment(dec?.next_english_yhartzeit)
            .utcOffset("+0100")
            .format(dateFormet),
        "next hebrew yahrzeit":
          dec?.next_hebrew_yhartzeit &&
          moment(dec?.next_hebrew_yhartzeit)
            .utcOffset("+0100")
            .format(dateFormet),
        "next observance yhartzeit":
          item?.nextObservanceYhartzeit &&
          moment(item?.nextObservanceYhartzeit)
            .utcOffset("+0100")
            .format(dateFormet),
      });
      return item;
    });
  });

  const mournersWithoutEmail = selectedMourners?.filter(
    (item) => !item?.member_id?.email_address && !item?.email
  );

  const getTemplateByType = async () => {
    setLoading(true);
    const token = await getAccessTokenSilently();
    try {
      const response = await FinancialSetting.getTemplateByType(
        token,
        "yehrzeit"
      );
      setTemplateContent(response?.result?.content?.replace(/&lt;/g, "<"));
      setFieldValue("template_id", response?.result?._id);
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Somthing Went Wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTemplateByType();
  }, []);
  const contentRef = useRef();

  const [imageLoading, setImageLoading] = useState(false);
  const [templateContentImage, setTemplateContentImage] = useState("");

  useEffect(() => {
    setImageLoading(true);
    const regex = /<img.*?src="(.*?)"/;
    const match = regex.exec(templateContent);
    const imgSrc = match && match[1];
    if (imgSrc) {
      toDataUrl(imgSrc, function (myBase64) {
        return setTemplateContentImage(myBase64);
      });
    }
    setImageLoading(false);
  }, [templateContent]);

  function toDataUrl(url, callback) {
    if (url !== null) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    }
  }

  const htmlRender = templateContent
    ?.replace(/&lt;/g, "<")
    ?.replace(/&nbsp;/g, " ");

  const regex = /<strong>(.*?)<\/strong>/gi; // Regex to match <strong> tags
  const boldItalic = htmlRender?.replace(
    /<strong>(?=.*?<em>(.*?)<\/em>).*?<\/strong>/gi,
    '<span style="font-weight: bold; font-style: italic; font-family: Helvetica-BoldOblique;">$1</span>'
  );
  const boldReplaced = boldItalic?.replace(
    regex,
    '<span style="font-family: Helvetica-Bold;">$1</span>'
  );
  const italicHtml = boldReplaced
    ?.replace(
      /<em>/g,
      "<span style='font-style: italic; font-family: Helvetica-Oblique;'>"
    )
    .replace(/<\/em>/g, "</span>");
  const italicHtmll = italicHtml?.replace(
    /<i>(.*?)<\/i>/gi,
    '<span style="font-style: italic; font-family: Helvetica-Oblique;">$1</span>'
  );
  const lineThroughHtml = italicHtmll
    ?.replace(/<del>/g, '<span style="text-decoration: line-through">')
    .replace(/<\/del>/g, "</span>");
  const replacedHtml = lineThroughHtml
    ?.replace(/<ins>/g, '<span style="text-decoration: underline">')
    .replace(/<\/ins>/g, "</span>");

  const downladAllMourners = () => {
    // eslint-disable-next-line no-unused-expressions
    mournersWithoutEmail?.forEach((item) => {
      generatePdfDocument(replacedHtml, item);
    });
    setFieldValue(
      "printed",
      mournersWithoutEmail?.map((item) => item?._id)
    );
  };

  Font.register({
    family: "Roboto",
    fonts: [
      {
        src: "https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Mu4mxK.woff2",
        fontWeight: 400,
      },
      {
        src: "https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlfBBc9.ttf",
        fontWeight: 700,
      },
    ],
  });

  const styles = StyleSheet.create({
    section: {
      padding: 30,
      fontStyle: "italic",
      flexDirection: "column",
      alignItems: "flex-start",
    },
    text: { fontSize: 10 },
    boldText: { fontWeight: "bold" },
    italicText: { fontStyle: "italic" },
    logo: {

      width: 130,
      height: 50
    },
    headerText: {
      paddingBottom: 5,
      fontSize: 13,
    },
    headerText: {
      paddingBottom: 5,
      fontSize: 13,
    },
  });
  const MyDocument = ({ data }) => {
    return (
      <Document>
        <Page size="A4">
          <View style={styles.section}>
            {addLogo ? (
              <>
                <Text style={styles.headerText}>{orgName}</Text>
                <Text style={styles.headerText}>{address}</Text>
                <Text style={styles.headerText}>{phone}</Text>
                <Image src={logoImg} style={styles.logo} />
              </>
            ) : null}
            <Html>{data}</Html>
          </View>
        </Page>
      </Document>
    );
  };

  const generatePdfDocument = async (htmlRender, item) => {
    const data = {
      ...item,
      ...item?.member_id,
    };

    const pdfFileName = item?.member_id?.full_name
      ? `Yehzreit Letter - ${item?.member_id?.full_name}`
      : item?.member_id?.first_name
      ? `Yehzreit Letter - ${item?.member_id?.first_name}`
      : `Yehzreit Letter - Mourner name`;

    //render the template with the data
    htmlRender = htmlRender?.replace(/\{\{([^}]+)\}\}/g, function (match, key) {
      return data[key] || "";
    });
    const blob = await pdf(<MyDocument {...{ data: htmlRender }} />).toBlob();
    saveAs(blob, pdfFileName);
  };

  return (
    <div className="non_recipients" ref={contentRef}>
      <div className="non_recipients__title">
        <h3> Non-Recipients </h3>
        <h3>{mournersWithoutEmail?.length}</h3>
      </div>
      <div className="listText">
        The following is a list of the {mournersWithoutEmail?.length}{" "}
        recipients.
      </div>
      <div className="printAll_btn" onClick={downladAllMourners}>
        <PrintIcon className="mr-3" /> Print All
      </div>
      <hr />
      <div className="mourner_list">
        {mournersWithoutEmail?.map((item) => (
          <MournerItem
            key={item?._id}
            id={item?._id}
            item={item}
            profile_img={item?.member_id?.profile_img}
            full_name={item?.member_id?.full_name}
            first_name={item?.member_id?.first_name}
            last_name={item?.member_id?.last_name}
            values={values}
            setFieldValue={setFieldValue}
            templateContent={templateContent}
            loading={loading}
            imageLoading={imageLoading}
            templateContentImage={templateContentImage}
          />
        ))}
      </div>
    </div>
  );
};

export default NonRecipientsMourners;
